import ToolPaneWrapper from "./ToolPaneWrapper";

export default ToolPaneWrapper;
